// extracted by mini-css-extract-plugin
module.exports = {"hidden":"join_hidden__XDmRt","textEmphasis":"join_textEmphasis__dwcTG","joinBtnArea":"join_joinBtnArea__U9U01","text":"join_text__I9pMI","btnJoin":"join_btnJoin__iCZ0v"};